import { FC } from 'react'

import { useTranslation } from 'react-i18next'

import { priceShow } from 'shared/lib//priceShow'

import { ImageLazy } from '../image-lazy'

import { Props } from './model'
import s from './styles.module.scss'

export const BlockCardPopular: FC<Props> = ({ image, title, price }) => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      {image && (
        <div className={s.image}>
          <ImageLazy
            src={image}
            alt={title}
          />
        </div>
      )}

      <p className={s.title}>{title}</p>
      <p className={s.subTitle}>
        {t('from_price', { price: priceShow(String(price)) })}
      </p>
    </div>
  )
}
